import { useUIStore } from "../../stores/ui";
import useAuthStore from "@/stores/auth";

export default function auth({ next, store }) {
  let isAuthenticated = !!store.token;
  let isNotFirstLogin = store.user.isChanged !== 0;

  if (isAuthenticated && isNotFirstLogin) {
    if (!store.user) useAuthStore().logout();
    let expired = new Date(store.user.expired);

    if (expired > new Date()) {
      useUIStore().layout = "layout-admin";
      return next();
    } else {
      useAuthStore().logout();
    }
  } else if (isAuthenticated && !isNotFirstLogin) {
    return next({ name: "changePassword" });
  }

  return next({
    name: "login",
  });
}
